import { usePModal } from '@pequity/squirrel';
import type { App, Plugin } from 'vue';

export const ModalPlugin: Plugin = {
  install(app: App) {
    app.config.globalProperties.$modal = usePModal();
  },
};
